export const moviesData =[
  {
    "": 0,
    "name": "Breathless",
    "joy": 0.14316239316239315,
    "sadness": 0.10363247863247864,
    "fear": 0.0673076923076923,
    "anger": 0.13354700854700854,
    "neutral": 377,
    "surprise": 0.14957264957264957,
    "total": 936,
    "id": "tt0053472",
    "rank": 705,
    "plot": "A small-time thief steals a car and impulsively murders a motorcycle policeman. Wanted by the authorities, he reunites with a hip American journalism student and attempts to persuade her to run away with him to Italy.",
    "poster": "https://m.media-amazon.com/images/M/MV5BNzk5MDk2MjktY2I3NS00ODZkLTk3OTktY2Q3ZDE2MmQ2M2ZmXkEyXkFqcGdeQXVyNjc1NTYyMjg@._V1_UY268_CR7,0,182,268_AL_.jpg"
  },
  {
    "": 1,
    "name": "The Hangover",
    "joy": 0.12695179904955872,
    "sadness": 0.10183299389002037,
    "fear": 0.07807196198234895,
    "anger": 0.1079429735234216,
    "neutral": 498,
    "surprise": 0.24711473183978275,
    "total": 1473,
    "id": "tt1119646",
    "rank": 743,
    "plot": "Three buddies wake up from a bachelor party in Las Vegas, with no memory of the previous night and the bachelor missing. They make their way around the city in order to find their friend before his wedding.",
    "poster": "https://m.media-amazon.com/images/M/MV5BNGQwZjg5YmYtY2VkNC00NzliLTljYTctNzI5NmU3MjE2ODQzXkEyXkFqcGdeQXVyNzkwMjQ5NzM@._V1_UX182_CR0,0,182,268_AL_.jpg"
  },
  {
    "": 2,
    "name": "The Vanishing",
    "joy": 0.06694560669456066,
    "sadness": 0.10181311018131102,
    "fear": 0.09902370990237098,
    "anger": 0.09065550906555091,
    "neutral": 339,
    "surprise": 0.16875871687587168,
    "total": 717,
    "id": "tt0096163",
    "rank": 823,
    "plot": "Rex and Saskia, a young couple in love, are on vacation. They stop at a busy service station and Saskia is abducted. After three years and no sign of Saskia, Rex begins receiving letters from the abductor.",
    "poster": "https://m.media-amazon.com/images/M/MV5BODk2NGU1ZjQtYmJjMS00N2IyLTg2MzgtMWIxYmY2MGJiN2I1XkEyXkFqcGdeQXVyMzg2MzE2OTE@._V1_UX182_CR0,0,182,268_AL_.jpg"
  },
  {
    "": 3,
    "name": "25th Hour",
    "joy": 0.12081678956324447,
    "sadness": 0.11117413499716393,
    "fear": 0.08621667612024958,
    "anger": 0.14237095859330687,
    "neutral": 598,
    "surprise": 0.20022688598979013,
    "total": 1763,
    "id": "tt0307901",
    "rank": 934,
    "plot": "Cornered by the DEA, convicted New York drug dealer Montgomery Brogan reevaluates his life in the 24 remaining hours before facing a seven-year jail term.",
    "poster": "https://m.media-amazon.com/images/M/MV5BNmE0YjdlYTktMTU4Ni00Mjk2LWI3NWMtM2RjNmFiOTk4YjYxL2ltYWdlXkEyXkFqcGdeQXVyNTAyODkwOQ@@._V1_UY268_CR4,0,182,268_AL_.jpg"
  },
  {
    "": 4,
    "name": "Planes, Trains and Automobiles",
    "joy": 0.16022889842632332,
    "sadness": 0.07296137339055794,
    "fear": 0.0844062947067239,
    "anger": 0.13590844062947066,
    "neutral": 233,
    "surprise": 0.21316165951359084,
    "total": 699,
    "id": "tt0093748",
    "rank": 974,
    "plot": "A man must struggle to travel home for Thanksgiving with a lovable oaf of a shower curtain ring salesman as his only companion.",
    "poster": "https://m.media-amazon.com/images/M/MV5BM2I1ZWNkYjEtYWY3ZS00MmMwLWI5OTEtNWNkZjNiYjIwNzY0XkEyXkFqcGdeQXVyNTI4MjkwNjA@._V1_UX182_CR0,0,182,268_AL_.jpg"
  },
  {
    "": 5,
    "name": "Infernal Affairs",
    "joy": 0.10589651022864019,
    "sadness": 0.05535499398315283,
    "fear": 0.28760529482551145,
    "anger": 0.07340553549939831,
    "neutral": 299,
    "surprise": 0.11793020457280386,
    "total": 831,
    "id": "tt0338564",
    "rank": 375,
    "plot": "A story between a mole in the police department and an undercover cop. Their objectives are the same: to find out who is the mole, and who is the cop.",
    "poster": "https://m.media-amazon.com/images/M/MV5BM2U0NTcxOTktN2MwZS00N2Q2LWJlYWItMTg0NWIyMDIxNzU5L2ltYWdlXkEyXkFqcGdeQXVyNTAyODkwOQ@@._V1_UY268_CR5,0,182,268_AL_.jpg"
  },
  {
    "": 6,
    "name": "Udaan",
    "joy": 0.12391304347826088,
    "sadness": 0.09347826086956522,
    "fear": 0.10869565217391304,
    "anger": 0.10434782608695652,
    "neutral": 640,
    "surprise": 0.10579710144927536,
    "total": 1380,
    "id": "tt1639426",
    "rank": 143,
    "plot": "Expelled from his school, a 16-year old boy returns home to his abusive and oppressive father.",
    "poster": ""
  },
  {
    "": 7,
    "name": "The Magnificent Seven",
    "joy": 0.1027450980392157,
    "sadness": 0.0596078431372549,
    "fear": 0.1192156862745098,
    "anger": 0.13098039215686275,
    "neutral": 518,
    "surprise": 0.1811764705882353,
    "total": 1275,
    "id": "tt0054047",
    "rank": 858,
    "plot": "Seven gunfighters are hired by Mexican peasants to liberate their village from oppressive bandits.",
    "poster": "https://m.media-amazon.com/images/M/MV5BMzYyNzU0MTM1OF5BMl5BanBnXkFtZTcwMzE1ODE1NA@@._V1_UX182_CR0,0,182,268_AL_.jpg"
  },
  {
    "": 8,
    "name": "Paper Moon",
    "joy": 0.17398119122257052,
    "sadness": 0.09090909090909091,
    "fear": 0.08855799373040753,
    "anger": 0.11833855799373041,
    "neutral": 487,
    "surprise": 0.14655172413793102,
    "total": 1276,
    "id": "tt0070510",
    "rank": 284,
    "plot": "During the Great Depression, a con man finds himself saddled with a young girl who may or may not be his daughter, and the two forge an unlikely partnership.",
    "poster": ""
  },
  {
    "": 9,
    "name": "Big Hero 6",
    "joy": 0.10588235294117647,
    "sadness": 0.07279411764705883,
    "fear": 0.1125,
    "anger": 0.07426470588235294,
    "neutral": 542,
    "surprise": 0.23602941176470588,
    "total": 1360,
    "id": "tt2245084",
    "rank": 590,
    "plot": "The special bond develops between plus-sized inflatable robot Baymax, and prodigy Hiro Hamada. They team up with a group of friends to form a band of high-tech heroes.",
    "poster": "https://m.media-amazon.com/images/M/MV5BMDliOTIzNmUtOTllOC00NDU3LWFiNjYtMGM0NDc1YTMxNjYxXkEyXkFqcGdeQXVyNTM3NzExMDQ@._V1_UY268_CR3,0,182,268_AL_.jpg"
  },
  {
    "": 10,
    "name": "The Peanut Butter Falcon",
    "joy": 0.10808709175738725,
    "sadness": 0.0583203732503888,
    "fear": 0.07931570762052877,
    "anger": 0.07309486780715396,
    "neutral": 560,
    "surprise": 0.24572317262830481,
    "total": 1286,
    "id": "tt4364194",
    "rank": 876,
    "plot": "Zak runs away from his care home to make his dream of becoming a wrestler come true.",
    "poster": "https://m.media-amazon.com/images/M/MV5BOWVmZGQ0MGYtMDI1Yy00MDkxLWJiYjQtMmZjZmQ0NDFmMDRhXkEyXkFqcGdeQXVyNjg3MDMxNzU@._V1_UX182_CR0,0,182,268_AL_.jpg"
  },
  {
    "": 11,
    "name": "Raiders of the Lost Ark",
    "joy": 0.11738148984198646,
    "sadness": 0.0654627539503386,
    "fear": 0.11286681715575621,
    "anger": 0.13205417607223477,
    "neutral": 373,
    "surprise": 0.15124153498871332,
    "total": 886,
    "id": "tt0082971",
    "rank": 73,
    "plot": "In 1936, archaeologist and adventurer Indiana Jones is hired by the U.S. government to find the Ark of the Covenant before",
    "poster": "https://m.media-amazon.com/images/M/MV5BMjA0ODEzMTc1Nl5BMl5BanBnXkFtZTcwODM2MjAxNA@@._V1_UX182_CR0,0,182,268_AL_.jpg"
  },
  {
    "": 12,
    "name": "Lost in Translation",
    "joy": 0.14433880726015558,
    "sadness": 0.07260155574762317,
    "fear": 0.08729472774416594,
    "anger": 0.05445116681071737,
    "neutral": 551,
    "surprise": 0.16508210890233363,
    "total": 1157,
    "id": "tt0335266",
    "rank": 773,
    "plot": "A faded movie star and a neglected young woman form an unlikely bond after crossing paths in Tokyo.",
    "poster": "https://m.media-amazon.com/images/M/MV5BMTI2NDI5ODk4N15BMl5BanBnXkFtZTYwMTI3NTE3._V1_UX182_CR0,0,182,268_AL_.jpg"
  },
  {
    "": 13,
    "name": "Gandhi",
    "joy": 0.1111111111111111,
    "sadness": 0.10878417684700407,
    "fear": 0.13670738801628854,
    "anger": 0.14077952297847585,
    "neutral": 754,
    "surprise": 0.06399069226294357,
    "total": 1719,
    "id": "tt0083987",
    "rank": 412,
    "plot": "The life of the lawyer who became the famed leader of the Indian revolts against the British rule through his philosophy of nonviolent protest.",
    "poster": "https://m.media-amazon.com/images/M/MV5BMzJiZDRmOWUtYjE2MS00Mjc1LTg1ZDYtNTQxYWJkZTg1OTM4XkEyXkFqcGdeQXVyNjUwNzk3NDc@._V1_UX182_CR0,0,182,268_AL_.jpg"
  },
  {
    "": 14,
    "name": "The Bridges of Madison County",
    "joy": 0.1467038068709378,
    "sadness": 0.14391829155060354,
    "fear": 0.08263695450324977,
    "anger": 0.06778087279480037,
    "neutral": 487,
    "surprise": 0.10677808727948004,
    "total": 1077,
    "id": "tt0112579",
    "rank": 959,
    "plot": "Photographer Robert Kincaid (",
    "poster": "https://m.media-amazon.com/images/M/MV5BNmRiZDZkN2EtNWI5ZS00ZDg3LTgyNDItMWI5NjVlNmE5ODJiXkEyXkFqcGdeQXVyMjQwMjk0NjI@._V1_UX182_CR0,0,182,268_AL_.jpg"
  },
  {
    "": 15,
    "name": "Home Alone",
    "joy": 0.17467248908296942,
    "sadness": 0.0890829694323144,
    "fear": 0.07685589519650655,
    "anger": 0.10131004366812227,
    "neutral": 491,
    "surprise": 0.12925764192139738,
    "total": 1145,
    "id": "tt0099785",
    "rank": 968,
    "plot": "An eight-year-old troublemaker must protect his house from a pair of burglars when he is accidentally left home alone by his family during Christmas vacation.",
    "poster": "https://m.media-amazon.com/images/M/MV5BMzFkM2YwOTQtYzk2Mi00N2VlLWE3NTItN2YwNDg1YmY0ZDNmXkEyXkFqcGdeQXVyMTMxODk2OTU@._V1_UX182_CR0,0,182,268_AL_.jpg"
  },
  {
    "": 16,
    "name": "Sling Blade",
    "joy": 0.15610599078341014,
    "sadness": 0.11059907834101383,
    "fear": 0.08179723502304148,
    "anger": 0.1359447004608295,
    "neutral": 646,
    "surprise": 0.1434331797235023,
    "total": 1736,
    "id": "tt0117666",
    "rank": 393,
    "plot": "Karl Childers, a simple man hospitalized since his childhood murder of his mother and her lover, is released to start a new life in a small town.",
    "poster": "https://m.media-amazon.com/images/M/MV5BNGY5NWIxMjAtODBjNC00MmZhLTk1ZTAtNGRhYThlOTNjMTQwXkEyXkFqcGdeQXVyNTc1NTQxODI@._V1_UX182_CR0,0,182,268_AL_.jpg"
  },
  {
    "": 17,
    "name": "Boyz n the Hood",
    "joy": 0.10302091402013942,
    "sadness": 0.060418280402788536,
    "fear": 0.09992254066615028,
    "anger": 0.1603408210689388,
    "neutral": 408,
    "surprise": 0.26026336173508907,
    "total": 1291,
    "id": "tt0101507",
    "rank": 666,
    "plot": "Follows the lives of three young males living in the Crenshaw ghetto of Los Angeles, dissecting questions of race, relationships, violence, and future prospects.",
    "poster": "https://m.media-amazon.com/images/M/MV5BZmRjNDI5NTgtOTIwMC00MzJhLWI4ZTYtMmU0ZTE3ZmRkZDNhXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_UX182_CR0,0,182,268_AL_.jpg"
  },
  {
    "": 18,
    "name": "A Bronx Tale",
    "joy": 0.14212827988338192,
    "sadness": 0.08600583090379009,
    "fear": 0.09475218658892129,
    "anger": 0.19533527696793002,
    "neutral": 398,
    "surprise": 0.19169096209912537,
    "total": 1372,
    "id": "tt0106489",
    "rank": 661,
    "plot": "A father becomes worried when a local gangster befriends his son in the Bronx in the 1960s.",
    "poster": ""
  },
  {
    "": 19,
    "name": "Dawn of the Planet of the Apes",
    "joy": 0.043037974683544304,
    "sadness": 0.07341772151898734,
    "fear": 0.15316455696202533,
    "anger": 0.09113924050632911,
    "neutral": 385,
    "surprise": 0.1518987341772152,
    "total": 790,
    "id": "tt2103281",
    "rank": 890,
    "plot": "A growing nation of genetically evolved apes led by Caesar is threatened by a band of human survivors of the devastating virus unleashed a decade earlier.",
    "poster": "https://m.media-amazon.com/images/M/MV5BMTgwODk3NDc1N15BMl5BanBnXkFtZTgwNTc1NjQwMjE@._V1_UX182_CR0,0,182,268_AL_.jpg"
  },
  {
    "": 20,
    "name": "Harry Potter and the Goblet of Fire",
    "joy": 0.12094861660079051,
    "sadness": 0.08458498023715415,
    "fear": 0.12173913043478261,
    "anger": 0.14071146245059288,
    "neutral": 492,
    "surprise": 0.14308300395256918,
    "total": 1265,
    "id": "tt0330373",
    "rank": 774,
    "plot": "Harry Potter finds himself competing in a hazardous tournament between rival schools of magic, but he is distracted by recurring nightmares.",
    "poster": "https://m.media-amazon.com/images/M/MV5BMTI1NDMyMjExOF5BMl5BanBnXkFtZTcwOTc4MjQzMQ@@._V1_UX182_CR0,0,182,268_AL_.jpg"
  },
  {
    "": 21,
    "name": "Gully Boy",
    "joy": 0.12034514078110808,
    "sadness": 0.07538601271571299,
    "fear": 0.17574931880108993,
    "anger": 0.12534059945504086,
    "neutral": 808,
    "surprise": 0.1362397820163488,
    "total": 2202,
    "id": "tt2395469",
    "rank": 206,
    "plot": "A coming-of-age story based on the lives of street rappers in Mumbai.",
    "poster": "https://m.media-amazon.com/images/M/MV5BZDkzMTQ1YTMtMWY4Ny00MzExLTkzYzEtNzZhOTczNzU2NTU1XkEyXkFqcGdeQXVyODY3NjMyMDU@._V1_UY268_CR11,0,182,268_AL_.jpg"
  },
  {
    "": 22,
    "name": "Dead Man",
    "joy": 0.10952380952380952,
    "sadness": 0.10095238095238095,
    "fear": 0.11333333333333333,
    "anger": 0.13238095238095238,
    "neutral": 450,
    "surprise": 0.11523809523809524,
    "total": 1050,
    "id": "tt0112817",
    "rank": 958,
    "plot": "On the run after murdering a man, accountant William Blake encounters a strange aboriginal American man named Nobody who prepares him for his journey into the spiritual world.",
    "poster": "https://m.media-amazon.com/images/M/MV5BYTJlZmQ1OTAtODQzZi00NGIzLWI1MmEtZGE4NjFlOWRhODIyXkEyXkFqcGdeQXVyNTc1NTQxODI@._V1_UY268_CR2,0,182,268_AL_.jpg"
  },
  {
    "": 23,
    "name": "The African Queen",
    "joy": 0.1272965879265092,
    "sadness": 0.09973753280839895,
    "fear": 0.16272965879265092,
    "anger": 0.09711286089238845,
    "neutral": 299,
    "surprise": 0.12073490813648294,
    "total": 762,
    "id": "tt0043265",
    "rank": 866,
    "plot": "In WWI Africa, a gin-swilling riverboat captain is persuaded by a strait-laced missionary to use his boat to attack an enemy warship.",
    "poster": "https://m.media-amazon.com/images/M/MV5BYzM3YjE2NGMtODY3Zi00NTY0LWE4Y2EtMTE5YzNmM2U1NTg2XkEyXkFqcGdeQXVyMTY5Nzc4MDY@._V1_UX182_CR0,0,182,268_AL_.jpg"
  },
  {
    "": 24,
    "name": "Crimes and Misdemeanors",
    "joy": 0.17349260523321958,
    "sadness": 0.15244596131968147,
    "fear": 0.07906712172923777,
    "anger": 0.1018202502844141,
    "neutral": 570,
    "surprise": 0.1689419795221843,
    "total": 1758,
    "id": "tt0097123",
    "rank": 526,
    "plot": "An ophthalmologist's mistress threatens to reveal their affair to his wife while a married documentary filmmaker is infatuated with another woman.",
    "poster": "https://m.media-amazon.com/images/M/MV5BYWY3N2EyOWYtNDVhZi00MWRkLTg2OTUtODNkNDQ5ZTIwMGJkXkEyXkFqcGdeQXVyMTMxODk2OTU@._V1_UX182_CR0,0,182,268_AL_.jpg"
  },
  {
    "": 25,
    "name": "Baby Driver",
    "joy": 0.12436363636363636,
    "sadness": 0.05745454545454545,
    "fear": 0.12945454545454546,
    "anger": 0.10690909090909091,
    "neutral": 554,
    "surprise": 0.1789090909090909,
    "total": 1375,
    "id": "tt3890160",
    "rank": 880,
    "plot": "After being coerced into working for a crime boss, a young getaway driver finds himself taking part in a heist doomed to fail.",
    "poster": "https://m.media-amazon.com/images/M/MV5BMjM3MjQ1MzkxNl5BMl5BanBnXkFtZTgwODk1ODgyMjI@._V1_UX182_CR0,0,182,268_AL_.jpg"
  },
  {
    "": 26,
    "name": "Heat",
    "joy": 0.08896210873146623,
    "sadness": 0.07029104887424492,
    "fear": 0.1070840197693575,
    "anger": 0.09829763866007687,
    "neutral": 832,
    "surprise": 0.17847336628226249,
    "total": 1821,
    "id": "tt0113277",
    "rank": 165,
    "plot": "A group of professional bank robbers start to feel the heat from police when they unknowingly leave a clue at their latest heist.",
    "poster": "https://m.media-amazon.com/images/M/MV5BNGMwNzUwNjYtZWM5NS00YzMyLWI4NjAtNjM0ZDBiMzE1YWExXkEyXkFqcGdeQXVyNDk3NzU2MTQ@._V1_UX182_CR0,0,182,268_AL_.jpg"
  },
  {
    "": 27,
    "name": "The Secret World of Arrietty",
    "joy": 0.16176470588235295,
    "sadness": 0.09803921568627451,
    "fear": 0.08006535947712418,
    "anger": 0.08006535947712418,
    "neutral": 256,
    "surprise": 0.16176470588235295,
    "total": 612,
    "id": "tt1568921",
    "rank": 894,
    "plot": "The Clock family are four-inch-tall people who live anonymously in another family's residence, borrowing simple items to make their home. Life changes for the Clocks when their teenage daughter, Arrietty, is discovered.",
    "poster": "https://m.media-amazon.com/images/M/MV5BZDY3ZGI0ZDAtMThlNy00MzAxLTg4YjAtNjkwYTkxNmQ4MjdlXkEyXkFqcGdeQXVyMTMxODk2OTU@._V1_UX182_CR0,0,182,268_AL_.jpg"
  },
  {
    "": 28,
    "name": "Raise the Red Lantern",
    "joy": 0.15222222222222223,
    "sadness": 0.08333333333333333,
    "fear": 0.04777777777777778,
    "anger": 0.17,
    "neutral": 396,
    "surprise": 0.10666666666666667,
    "total": 900,
    "id": "tt0101640",
    "rank": 264,
    "plot": "A young woman becomes the fourth wife of a wealthy lord, and must learn to live with the strict rules and tensions within the household.",
    "poster": ""
  },
  {
    "": 29,
    "name": "Au Revoir les Enfants",
    "joy": 0.13172338090010977,
    "sadness": 0.10428100987925357,
    "fear": 0.09549945115257959,
    "anger": 0.1525795828759605,
    "neutral": 374,
    "surprise": 0.10537870472008781,
    "total": 911,
    "id": "tt0092593",
    "rank": 409,
    "plot": "A French boarding school run by priests seems to be a haven from World War II until a new student arrives. He becomes the roommate of the top student in his class. Rivals at first, the roommates form a bond and share a secret.",
    "poster": "https://m.media-amazon.com/images/M/MV5BZmYxOTA5YTEtNDY3Ni00YTE5LWE1MTgtYjc4ZWUxNWY3ZTkxXkEyXkFqcGdeQXVyNjQ2MjQ5NzM@._V1_UX182_CR0,0,182,268_AL_.jpg"
  },
  {
    "": 30,
    "name": "The Help",
    "joy": 0.14613368283093053,
    "sadness": 0.10550458715596331,
    "fear": 0.09764089121887287,
    "anger": 0.12123197903014417,
    "neutral": 589,
    "surprise": 0.1435124508519004,
    "total": 1526,
    "id": "tt1454029",
    "rank": 348,
    "plot": "An aspiring author during the civil rights movement of the 1960s decides to write a book detailing the African American maids' point of view on the white families for which they work, and the hardships they go through on a daily basis.",
    "poster": "https://m.media-amazon.com/images/M/MV5BMTM5OTMyMjIxOV5BMl5BanBnXkFtZTcwNzU4MjIwNQ@@._V1_UX182_CR0,0,182,268_AL_.jpg"
  },
  {
    "": 31,
    "name": "12 Angry Men",
    "joy": 0.08698260347930414,
    "sadness": 0.07798440311937613,
    "fear": 0.10677864427114576,
    "anger": 0.14817036592681462,
    "neutral": 688,
    "surprise": 0.16736652669466107,
    "total": 1667,
    "id": "tt0050083",
    "rank": 6,
    "plot": "A jury holdout attempts to prevent a miscarriage of justice by forcing his colleagues to reconsider the evidence.",
    "poster": "https://m.media-amazon.com/images/M/MV5BMWU4N2FjNzYtNTVkNC00NzQ0LTg0MjAtYTJlMjFhNGUxZDFmXkEyXkFqcGdeQXVyNjc1NTYyMjg@._V1_UX182_CR0,0,182,268_AL_.jpg"
  },
  {
    "": 32,
    "name": "The Bourne Ultimatum",
    "joy": 0.06631578947368422,
    "sadness": 0.06421052631578947,
    "fear": 0.18736842105263157,
    "anger": 0.06947368421052631,
    "neutral": 457,
    "surprise": 0.13157894736842105,
    "total": 950,
    "id": "tt0440963",
    "rank": 362,
    "plot": "Jason Bourne dodges a ruthless C.I.A. official and his Agents from a new assassination program while searching for the origins of his life as a trained killer.",
    "poster": ""
  },
  {
    "": 33,
    "name": "Soorarai Pottru",
    "joy": 0.11940298507462686,
    "sadness": 0.06055437100213219,
    "fear": 0.1091684434968017,
    "anger": 0.21577825159914713,
    "neutral": 852,
    "surprise": 0.13176972281449895,
    "total": 2345,
    "id": "tt10189514",
    "rank": 3,
    "plot": "Nedumaaran Rajangam \"Maara\" sets out to make the common man fly and in the process takes on the world's most capital intensive industry and several enemies who stand in his way.",
    "poster": "https://m.media-amazon.com/images/M/MV5BOTc2ZTlmYmItMDBhYS00YmMzLWI4ZjAtMTI5YTBjOTFiMGEwXkEyXkFqcGdeQXVyODE5NzE3OTE@._V1_UY268_CR2,0,182,268_AL_.jpg"
  },
  {
    "": 34,
    "name": "In Bruges",
    "joy": 0.10161870503597123,
    "sadness": 0.09442446043165467,
    "fear": 0.10071942446043165,
    "anger": 0.1591726618705036,
    "neutral": 375,
    "surprise": 0.2068345323741007,
    "total": 1112,
    "id": "tt0780536",
    "rank": 495,
    "plot": "Guilt-stricken after a job gone wrong, hitman Ray and his partner await orders from their ruthless boss in Bruges, Belgium, the last place in the world Ray wants to be.",
    "poster": "https://m.media-amazon.com/images/M/MV5BMTUwOGFiM2QtOWMxYS00MjU2LThmZDMtZDM2MWMzNzllNjdhXkEyXkFqcGdeQXVyMTMxODk2OTU@._V1_UX182_CR0,0,182,268_AL_.jpg"
  },
  {
    "": 35,
    "name": "Trainspotting",
    "joy": 0.13297297297297297,
    "sadness": 0.1372972972972973,
    "fear": 0.14162162162162162,
    "anger": 0.17405405405405405,
    "neutral": 272,
    "surprise": 0.12,
    "total": 925,
    "id": "tt0117951",
    "rank": 254,
    "plot": "Renton, deeply immersed in the Edinburgh drug scene, tries to clean up and get out, despite the allure of the drugs and influence of friends.",
    "poster": "https://m.media-amazon.com/images/M/MV5BMzA5Zjc3ZTMtMmU5YS00YTMwLWI4MWUtYTU0YTVmNjVmODZhXkEyXkFqcGdeQXVyNjU0OTQ0OTY@._V1_UX182_CR0,0,182,268_AL_.jpg"
  },
  {
    "": 36,
    "name": "Drive",
    "joy": 0.10666666666666667,
    "sadness": 0.08444444444444445,
    "fear": 0.13333333333333333,
    "anger": 0.1811111111111111,
    "neutral": 270,
    "surprise": 0.19444444444444445,
    "total": 900,
    "id": "tt0780504",
    "rank": 618,
    "plot": "A mysterious Hollywood stuntman and mechanic moonlights as a getaway driver and finds himself in trouble when he helps out his neighbor in this action drama.",
    "poster": "https://m.media-amazon.com/images/M/MV5BZjY5ZjQyMjMtMmEwOC00Nzc2LTllYTItMmU2MzJjNTg1NjY0XkEyXkFqcGdeQXVyNjQ1MTMzMDQ@._V1_UX182_CR0,0,182,268_AL_.jpg"
  },
  {
    "": 37,
    "name": "Guardians of the Galaxy Vol. 2",
    "joy": 0.1137005649717514,
    "sadness": 0.10240112994350282,
    "fear": 0.12641242937853106,
    "anger": 0.15112994350282485,
    "neutral": 447,
    "surprise": 0.1906779661016949,
    "total": 1416,
    "id": "tt3896198",
    "rank": 879,
    "plot": "The Guardians struggle to keep together as a team while dealing with their personal family issues, notably Star-Lord's encounter with his father the ambitious celestial being Ego.",
    "poster": "https://m.media-amazon.com/images/M/MV5BNjM0NTc0NzItM2FlYS00YzEwLWE0YmUtNTA2ZWIzODc2OTgxXkEyXkFqcGdeQXVyNTgwNzIyNzg@._V1_UX182_CR0,0,182,268_AL_.jpg"
  },
  {
    "": 38,
    "name": "The Salesman",
    "joy": 0.07878411910669975,
    "sadness": 0.09119106699751861,
    "fear": 0.10421836228287841,
    "anger": 0.11600496277915633,
    "neutral": 675,
    "surprise": 0.19106699751861042,
    "total": 1612,
    "id": "tt5186714",
    "rank": 571,
    "plot": "While both participating in a production of \"Death of a Salesman,\" a teacher's wife is assaulted in her new home, which leaves him determined to find the perpetrator over his wife's traumatized objections.",
    "poster": "https://m.media-amazon.com/images/M/MV5BMTg2MTc0ODEwOV5BMl5BanBnXkFtZTgwNDAyOTY1MDI@._V1_UY268_CR1,0,182,268_AL_.jpg"
  },
  {
    "": 39,
    "name": "This Is Spinal Tap",
    "joy": 0.1422172452407615,
    "sadness": 0.07446808510638298,
    "fear": 0.10918253079507279,
    "anger": 0.0677491601343785,
    "neutral": 805,
    "surprise": 0.15565509518477044,
    "total": 1786,
    "id": "tt0088258",
    "rank": 530,
    "plot": "Spinal Tap, one of England's loudest bands, is chronicled by film director Marty DiBergi on what proves to be a fateful tour.",
    "poster": "https://m.media-amazon.com/images/M/MV5BMTQ2MTIzMzg5Nl5BMl5BanBnXkFtZTgwOTc5NDI1MDE@._V1_UX182_CR0,0,182,268_AL_.jpg"
  },
  {
    "": 40,
    "name": "Good Will Hunting",
    "joy": 0.14536015574302402,
    "sadness": 0.09344581440622972,
    "fear": 0.09149902660609993,
    "anger": 0.1317326411421155,
    "neutral": 509,
    "surprise": 0.20765736534717716,
    "total": 1541,
    "id": "tt0119217",
    "rank": 102,
    "plot": "Will Hunting, a janitor at M.I.T., has a gift for mathematics, but needs help from a psychologist to find direction in his life.",
    "poster": "https://m.media-amazon.com/images/M/MV5BOTI0MzcxMTYtZDVkMy00NjY1LTgyMTYtZmUxN2M3NmQ2NWJhXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_UX182_CR0,0,182,268_AL_.jpg"
  },
  {
    "": 41,
    "name": "Fireworks",
    "joy": 0.09002433090024331,
    "sadness": 0.1362530413625304,
    "fear": 0.12652068126520682,
    "anger": 0.11435523114355231,
    "neutral": 168,
    "surprise": 0.12408759124087591,
    "total": 411,
    "id": "tt0119250",
    "rank": 650,
    "plot": "Nishi leaves the police in the face of harrowing personal and professional difficulties. Spiraling into depression, he makes questionable decisions.",
    "poster": ""
  },
  {
    "": 42,
    "name": "Million Dollar Baby",
    "joy": 0.12742382271468145,
    "sadness": 0.08448753462603878,
    "fear": 0.10457063711911357,
    "anger": 0.13434903047091412,
    "neutral": 564,
    "surprise": 0.15858725761772854,
    "total": 1444,
    "id": "tt0405159",
    "rank": 235,
    "plot": "A determined woman works with a hardened boxing trainer to become a professional.",
    "poster": "https://m.media-amazon.com/images/M/MV5BMTkxNzA1NDQxOV5BMl5BanBnXkFtZTcwNTkyMTIzMw@@._V1_UX182_CR0,0,182,268_AL_.jpg"
  },
  {
    "": 43,
    "name": "Badlands",
    "joy": 0.1474820143884892,
    "sadness": 0.1510791366906475,
    "fear": 0.21942446043165467,
    "anger": 0.10071942446043165,
    "neutral": 88,
    "surprise": 0.06474820143884892,
    "total": 278,
    "id": "tt0069762",
    "rank": 693,
    "plot": "An impressionable teenage girl from a dead-end town and her older greaser boyfriend embark on a killing spree in the South Dakota badlands.",
    "poster": "https://m.media-amazon.com/images/M/MV5BMDcxNjhiOTEtMzQ0YS00OTBhLTkxM2QtN2UyZDMzNzIzNWFlXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_UY268_CR4,0,182,268_AL_.jpg"
  },
  {
    "": 44,
    "name": "Red River",
    "joy": 0.10807113543091655,
    "sadness": 0.07523939808481532,
    "fear": 0.11422708618331054,
    "anger": 0.09233926128590972,
    "neutral": 648,
    "surprise": 0.16689466484268126,
    "total": 1462,
    "id": "tt0040724",
    "rank": 706,
    "plot": "Dunson leads a cattle drive, the culmination of over 14 years of work, to its destination in Missouri. But his tyrannical behavior along the way causes a mutiny, led by his adopted son.",
    "poster": "https://m.media-amazon.com/images/M/MV5BNzNiOGJhMDUtZjNjMC00YmE5LTk3NjQtNGM4ZjAzOGJjZmRlXkEyXkFqcGdeQXVyNjc1NTYyMjg@._V1_UX182_CR0,0,182,268_AL_.jpg"
  },
  {
    "": 45,
    "name": "Lifeboat",
    "joy": 0.12682551883166795,
    "sadness": 0.0883935434281322,
    "fear": 0.1037663335895465,
    "anger": 0.13835511145272866,
    "neutral": 499,
    "surprise": 0.15910837817063797,
    "total": 1301,
    "id": "tt0037017",
    "rank": 998,
    "plot": "Several survivors of a torpedoed merchant ship in World War II find themselves in the same lifeboat with one of the U-boat men who sunk it.",
    "poster": "https://m.media-amazon.com/images/M/MV5BZTBmMjUyMjItYTM4ZS00MjAwLWEyOGYtYjMyZTUxN2I3OTMxXkEyXkFqcGdeQXVyNjc1NTYyMjg@._V1_UX182_CR0,0,182,268_AL_.jpg"
  },
  {
    "": 46,
    "name": "Key Largo",
    "joy": 0.11355571327182398,
    "sadness": 0.0823278921220724,
    "fear": 0.0965223562810504,
    "anger": 0.11781405251951739,
    "neutral": 606,
    "surprise": 0.1596877217885025,
    "total": 1409,
    "id": "tt0040506",
    "rank": 707,
    "plot": "A man visits his war buddy's family hotel and finds a gangster running things. As a hurricane approaches, the two end up confronting each other.",
    "poster": "https://m.media-amazon.com/images/M/MV5BODI3YzNiZTUtYjEyZS00ODkwLWE2ZDUtNGJmMTNiYTc4ZTM4XkEyXkFqcGdeQXVyMDI2NDg0NQ@@._V1_UX182_CR0,0,182,268_AL_.jpg"
  },
  {
    "": 47,
    "name": "E.T. the Extra-Terrestrial",
    "joy": 0.07990867579908675,
    "sadness": 0.05821917808219178,
    "fear": 0.08333333333333333,
    "anger": 0.08447488584474885,
    "neutral": 474,
    "surprise": 0.15296803652968036,
    "total": 876,
    "id": "tt0083866",
    "rank": 685,
    "plot": "A troubled child summons the courage to help a friendly alien escape Earth and return to his home world.",
    "poster": "https://m.media-amazon.com/images/M/MV5BMTQ2ODFlMDAtNzdhOC00ZDYzLWE3YTMtNDU4ZGFmZmJmYTczXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_UX182_CR0,0,182,268_AL_.jpg"
  },
  {
    "": 48,
    "name": "American Gangster",
    "joy": 0.11996933691069375,
    "sadness": 0.053660406285933306,
    "fear": 0.0858566500574933,
    "anger": 0.12150249137600613,
    "neutral": 1027,
    "surprise": 0.2253737064009199,
    "total": 2609,
    "id": "tt0765429",
    "rank": 619,
    "plot": "An outcast New York City cop is charged with bringing down Harlem drug lord Frank Lucas, whose real life inspired this partly biographical film.",
    "poster": "https://m.media-amazon.com/images/M/MV5BMjFmZGI2YTEtYmJhMS00YTE5LWJjNjAtNDI5OGY5ZDhmNTRlXkEyXkFqcGdeQXVyODAwMTU1MTE@._V1_UX182_CR0,0,182,268_AL_.jpg"
  },
  {
    "": 49,
    "name": "Scent of a Woman",
    "joy": 0.14217098943323728,
    "sadness": 0.07204610951008646,
    "fear": 0.0787704130643612,
    "anger": 0.11911623439000961,
    "neutral": 894,
    "surprise": 0.1585014409221902,
    "total": 2082,
    "id": "tt0105323",
    "rank": 400,
    "plot": "A prep school student needing money agrees to \"babysit\" a blind man, but the job is not at all what he anticipated.",
    "poster": ""
  },
  {
    "": 50,
    "name": "The Purple Rose of Cairo",
    "joy": 0.21365638766519823,
    "sadness": 0.16519823788546256,
    "fear": 0.09140969162995595,
    "anger": 0.11563876651982379,
    "neutral": 241,
    "surprise": 0.1486784140969163,
    "total": 908,
    "id": "tt0089853",
    "rank": 829,
    "plot": "In New Jersey in 1935, a movie character walks off the screen and into the real world.",
    "poster": "https://m.media-amazon.com/images/M/MV5BY2E1YWRlNzAtYzAwYy00MDg5LTlmYTUtYjdlZDI0NzFkNjNlL2ltYWdlL2ltYWdlXkEyXkFqcGdeQXVyNjQ2MjQ5NzM@._V1_UX182_CR0,0,182,268_AL_.jpg"
  },
  {
    "": 51,
    "name": "The Bourne Identity",
    "joy": 0.052444444444444446,
    "sadness": 0.09422222222222222,
    "fear": 0.08888888888888889,
    "anger": 0.07466666666666667,
    "neutral": 557,
    "surprise": 0.19466666666666665,
    "total": 1125,
    "id": "tt0258463",
    "rank": 512,
    "plot": "A man is picked up by a fishing boat, bullet-riddled and suffering from amnesia, before racing to elude assassins and attempting to regain his memory.",
    "poster": "https://m.media-amazon.com/images/M/MV5BM2JkNGU0ZGMtZjVjNS00NjgyLWEyOWYtZmRmZGQyN2IxZjA2XkEyXkFqcGdeQXVyNTIzOTk5ODM@._V1_UX182_CR0,0,182,268_AL_.jpg"
  },
  {
    "": 52,
    "name": "True Grit",
    "joy": 0.10048231511254019,
    "sadness": 0.1302250803858521,
    "fear": 0.1527331189710611,
    "anger": 0.1527331189710611,
    "neutral": 459,
    "surprise": 0.09485530546623794,
    "total": 1244,
    "id": "tt1403865",
    "rank": 896,
    "plot": "A stubborn teenager enlists the help of a tough U.S. Marshal to track down her father's murderer.",
    "poster": "https://m.media-amazon.com/images/M/MV5BODhkZDIzNjgtOTA5ZS00MmMzLWFkNjYtM2Y2MzFjN2FkNjAzL2ltYWdlXkEyXkFqcGdeQXVyNTAyODkwOQ@@._V1_UY268_CR2,0,182,268_AL_.jpg"
  },
  {
    "": 53,
    "name": "The Girl with the Dragon Tattoo",
    "joy": 0.12905551550108146,
    "sadness": 0.14635904830569574,
    "fear": 0.11463590483056957,
    "anger": 0.10310021629416005,
    "neutral": 585,
    "surprise": 0.08507570295602018,
    "total": 1387,
    "id": "tt1132620",
    "rank": 610,
    "plot": "A journalist is aided by a young female hacker in his search for the killer of a woman who has been dead for forty years.",
    "poster": "https://m.media-amazon.com/images/M/MV5BMTc2Mjc0MDg3MV5BMl5BanBnXkFtZTcwMjUzMDkxMw@@._V1_UX182_CR0,0,182,268_AL_.jpg"
  },
  {
    "": 54,
    "name": "The Girl with the Dragon Tattoo",
    "joy": 0.12905551550108146,
    "sadness": 0.14635904830569574,
    "fear": 0.11463590483056957,
    "anger": 0.10310021629416005,
    "neutral": 585,
    "surprise": 0.08507570295602018,
    "total": 1387,
    "id": "tt1568346",
    "rank": 602,
    "plot": "Journalist Mikael Blomkvist is aided in his search for a woman who has been missing for forty years by Lisbeth Salander, a young computer hacker.",
    "poster": "https://m.media-amazon.com/images/M/MV5BMTczNDk4NTQ0OV5BMl5BanBnXkFtZTcwNDAxMDgxNw@@._V1_UX182_CR0,0,182,268_AL_.jpg"
  },
  {
    "": 55,
    "name": "A Night at the Opera",
    "joy": 0.18985976267529667,
    "sadness": 0.08090614886731391,
    "fear": 0.05393743257820928,
    "anger": 0.15318230852211434,
    "neutral": 373,
    "surprise": 0.11974110032362459,
    "total": 927,
    "id": "tt0026778",
    "rank": 565,
    "plot": "A sly business manager and two wacky friends of two opera singers help them achieve success while humiliating their stuffy and snobbish enemies.",
    "poster": "https://m.media-amazon.com/images/M/MV5BYTJmNmQxNGItNDNlMC00MDU3LWFhNzMtZDQ2NDY0ZTVkNjE3XkEyXkFqcGdeQXVyMDI2NDg0NQ@@._V1_UX182_CR0,0,182,268_AL_.jpg"
  },
  {
    "": 56,
    "name": "Ed Wood",
    "joy": 0.1582403151674327,
    "sadness": 0.09258043335521995,
    "fear": 0.09717662508207485,
    "anger": 0.09520682862770848,
    "neutral": 571,
    "surprise": 0.1818778726198293,
    "total": 1523,
    "id": "tt0109707",
    "rank": 654,
    "plot": "Ambitious but troubled movie director",
    "poster": "https://m.media-amazon.com/images/M/MV5BNTA5ZjdjNWUtZGUwNy00N2RhLWJiZmItYzFhYjU1NmYxNjY4XkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_UX182_CR0,0,182,268_AL_.jpg"
  },
  {
    "": 57,
    "name": "Tenet",
    "joy": 0.08262910798122065,
    "sadness": 0.09139280125195619,
    "fear": 0.16651017214397495,
    "anger": 0.11001564945226917,
    "neutral": 2801,
    "surprise": 0.1111111111111111,
    "total": 6390,
    "id": "tt6723592",
    "rank": 570,
    "plot": "Armed with only one word, Tenet, and fighting for the survival of the entire world, a Protagonist journeys through a twilight world of international espionage on a mission that will unfold in something beyond real time.",
    "poster": "https://m.media-amazon.com/images/M/MV5BYzg0NGM2NjAtNmIxOC00MDJmLTg5ZmYtYzM0MTE4NWE2NzlhXkEyXkFqcGdeQXVyMTA4NjE0NjEy._V1_UX182_CR0,0,182,268_AL_.jpg"
  },
  {
    "": 58,
    "name": "Black Book",
    "joy": 0.14800759013282733,
    "sadness": 0.08823529411764706,
    "fear": 0.11764705882352941,
    "anger": 0.13851992409867173,
    "neutral": 428,
    "surprise": 0.1015180265654649,
    "total": 1054,
    "id": "tt0389557",
    "rank": 765,
    "plot": "In the Nazi-occupied Netherlands during World War II, a Jewish singer infiltrates the regional Gestapo headquarters for the Dutch resistance.",
    "poster": "https://m.media-amazon.com/images/M/MV5BODFlNTI0ZWQtOTcxNC00OTc0LTkwZDUtMmNkM2I1ZWFlYzZkXkEyXkFqcGdeQXVyNTIzOTk5ODM@._V1_UY268_CR7,0,182,268_AL_.jpg"
  },
  {
    "": 59,
    "name": "Blow",
    "joy": 0.15472415979708307,
    "sadness": 0.08243500317057705,
    "fear": 0.06721623335447051,
    "anger": 0.10906785034876347,
    "neutral": 673,
    "surprise": 0.15979708306911858,
    "total": 1577,
    "id": "tt0221027",
    "rank": 942,
    "plot": "The story of how",
    "poster": "https://m.media-amazon.com/images/M/MV5BYjg5ZDkzZWEtZDQ2ZC00Y2ViLThhMzYtMmIxZDYzYTY2Y2Y2XkEyXkFqcGdeQXVyODAwMTU1MTE@._V1_UY268_CR3,0,182,268_AL_.jpg"
  },
  {
    "": 60,
    "name": "Se7en",
    "joy": 0.08793686583990981,
    "sadness": 0.09019165727170236,
    "fear": 0.10822998872604284,
    "anger": 0.12288613303269448,
    "neutral": 743,
    "surprise": 0.17192784667418265,
    "total": 1774,
    "id": "tt0114369",
    "rank": 28,
    "plot": "Two detectives, a rookie and a veteran, hunt a serial killer who uses the seven deadly sins as his motives.",
    "poster": "https://m.media-amazon.com/images/M/MV5BOTUwODM5MTctZjczMi00OTk4LTg3NWUtNmVhMTAzNTNjYjcyXkEyXkFqcGdeQXVyNjU0OTQ0OTY@._V1_UX182_CR0,0,182,268_AL_.jpg"
  },
  {
    "": 61,
    "name": "Sherlock Holmes",
    "joy": 0.14957264957264957,
    "sadness": 0.10170940170940171,
    "fear": 0.152991452991453,
    "anger": 0.11282051282051282,
    "neutral": 488,
    "surprise": 0.06581196581196581,
    "total": 1170,
    "id": "tt0988045",
    "rank": 906,
    "plot": "Detective Sherlock Holmes and his stalwart partner Watson engage in a battle of wits and brawn with a nemesis whose plot is a threat to all of England.",
    "poster": "https://m.media-amazon.com/images/M/MV5BMTg0NjEwNjUxM15BMl5BanBnXkFtZTcwMzk0MjQ5Mg@@._V1_UX182_CR0,0,182,268_AL_.jpg"
  },
  {
    "": 62,
    "name": "Once Were Warriors",
    "joy": 0.1493877551020408,
    "sadness": 0.09959183673469388,
    "fear": 0.07183673469387755,
    "anger": 0.16163265306122448,
    "neutral": 384,
    "surprise": 0.20408163265306123,
    "total": 1225,
    "id": "tt0110729",
    "rank": 519,
    "plot": "A family descended from Maori warriors is bedeviled by a violent father and the societal problems of being treated as outcasts.",
    "poster": "https://m.media-amazon.com/images/M/MV5BYTY4MTdjZDMtOTBiMC00MDEwLThhMjUtMjlhMjdlYTBmMzk3XkEyXkFqcGdeQXVyNjMwMjk0MTQ@._V1_UY268_CR3,0,182,268_AL_.jpg"
  },
  {
    "": 63,
    "name": "The Bandit",
    "joy": 0.09728506787330317,
    "sadness": 0.05429864253393665,
    "fear": 0.252262443438914,
    "anger": 0.11764705882352941,
    "neutral": 245,
    "surprise": 0.20135746606334842,
    "total": 884,
    "id": "tt0116231",
    "rank": 164,
    "plot": "Baran the Bandit, released from prison after 35 years, searches for vengeance and his lover.",
    "poster": ""
  },
  {
    "": 64,
    "name": "Platoon",
    "joy": 0.06582077716098335,
    "sadness": 0.052339413164155434,
    "fear": 0.18556701030927836,
    "anger": 0.17446471054718476,
    "neutral": 408,
    "surprise": 0.19825535289452814,
    "total": 1261,
    "id": "tt0091763",
    "rank": 268,
    "plot": "A young soldier in Vietnam faces a moral crisis when confronted with the horrors of war and the duality of man.",
    "poster": "https://m.media-amazon.com/images/M/MV5BMzRjZjdlMjQtODVkYS00N2YzLWJlYWYtMGVlN2E5MWEwMWQzXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_UX182_CR0,0,182,268_AL_.jpg"
  },
  {
    "": 65,
    "name": "Shutter Island",
    "joy": 0.07584269662921349,
    "sadness": 0.11025280898876405,
    "fear": 0.1446629213483146,
    "anger": 0.125,
    "neutral": 539,
    "surprise": 0.16573033707865167,
    "total": 1424,
    "id": "tt1130884",
    "rank": 147,
    "plot": "In 1954, a U.S. Marshal investigates the disappearance of a murderer who escaped from a hospital for the criminally insane.",
    "poster": "https://m.media-amazon.com/images/M/MV5BYzhiNDkyNzktNTZmYS00ZTBkLTk2MDAtM2U0YjU1MzgxZjgzXkEyXkFqcGdeQXVyMTMxODk2OTU@._V1_UX182_CR0,0,182,268_AL_.jpg"
  },
  {
    "": 66,
    "name": "Chungking Express",
    "joy": 0.12458286985539488,
    "sadness": 0.11345939933259176,
    "fear": 0.0878754171301446,
    "anger": 0.07119021134593993,
    "neutral": 409,
    "surprise": 0.14794215795328142,
    "total": 899,
    "id": "tt0109424",
    "rank": 261,
    "plot": "Two melancholy Hong Kong policemen fall in love: one with a mysterious female underworld figure, the other with a beautiful and ethereal server at a late-night restaurant he frequents.",
    "poster": "https://m.media-amazon.com/images/M/MV5BMGQ5MzljNzYtMDM1My00NmI0LThlYzQtMTg0ZmQ0MTk1YjkxXkEyXkFqcGdeQXVyNTAyODkwOQ@@._V1_UY268_CR4,0,182,268_AL_.jpg"
  },
  {
    "": 67,
    "name": "The Maltese Falcon",
    "joy": 0.1343390804597701,
    "sadness": 0.09051724137931035,
    "fear": 0.07974137931034483,
    "anger": 0.17456896551724138,
    "neutral": 582,
    "surprise": 0.10272988505747127,
    "total": 1392,
    "id": "tt0033870",
    "rank": 457,
    "plot": "A private detective takes on a case that involves him with three eccentric criminals, a gorgeous liar, and their quest for a priceless statuette.",
    "poster": "https://m.media-amazon.com/images/M/MV5BZjIwNGM1ZTUtOThjYS00NDdiLTk2ZDYtNGY5YjJkNzliM2JjL2ltYWdlL2ltYWdlXkEyXkFqcGdeQXVyMDI2NDg0NQ@@._V1_UX182_CR0,0,182,268_AL_.jpg"
  },
  {
    "": 68,
    "name": "The Breakfast Club",
    "joy": 0.07088607594936709,
    "sadness": 0.0810126582278481,
    "fear": 0.07257383966244725,
    "anger": 0.17721518987341772,
    "neutral": 447,
    "surprise": 0.2210970464135021,
    "total": 1185,
    "id": "tt0088847",
    "rank": 680,
    "plot": "Five high school students meet in Saturday detention and discover how they have a lot more in common than they thought.",
    "poster": "https://m.media-amazon.com/images/M/MV5BOTM5N2ZmZTMtNjlmOS00YzlkLTk3YjEtNTU1ZmQ5OTdhODZhXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_UX182_CR0,0,182,268_AL_.jpg"
  },
  {
    "": 69,
    "name": "Skyfall",
    "joy": 0.1091581868640148,
    "sadness": 0.0851063829787234,
    "fear": 0.14338575393154487,
    "anger": 0.0841813135985199,
    "neutral": 529,
    "surprise": 0.08880666049953746,
    "total": 1081,
    "id": "tt1074638",
    "rank": 744,
    "plot": "James Bond's loyalty to M is tested when her past comes back to haunt her. When MI6 comes under attack, 007 must track down and destroy the threat, no matter how personal the cost.",
    "poster": "https://m.media-amazon.com/images/M/MV5BMWZiNjE2OWItMTkwNy00ZWQzLWI0NTgtMWE0NjNiYTljN2Q1XkEyXkFqcGdeQXVyNzAwMjYxMzA@._V1_UX182_CR0,0,182,268_AL_.jpg"
  },
  {
    "": 70,
    "name": "Man on Fire",
    "joy": 0.11011011011011011,
    "sadness": 0.09309309309309309,
    "fear": 0.08608608608608609,
    "anger": 0.08108108108108109,
    "neutral": 445,
    "surprise": 0.1841841841841842,
    "total": 999,
    "id": "tt0328107",
    "rank": 775,
    "plot": "In Mexico City, a former CIA operative swears vengeance on those who committed an unspeakable act against the family he was hired to protect.",
    "poster": "https://m.media-amazon.com/images/M/MV5BODFlMmEwMDgtYjhmZi00ZTE5LTk2NWQtMWE1Y2M0NjkzOGYxXkEyXkFqcGdeQXVyNjU0OTQ0OTY@._V1_UY268_CR0,0,182,268_AL_.jpg"
  },
  {
    "": 71,
    "name": "Gone with the Wind",
    "joy": 0.15081863979848867,
    "sadness": 0.1265743073047859,
    "fear": 0.08532745591939547,
    "anger": 0.16750629722921914,
    "neutral": 995,
    "surprise": 0.15648614609571787,
    "total": 3176,
    "id": "tt0031381",
    "rank": 315,
    "plot": "A manipulative woman and a roguish man conduct a turbulent romance during the American Civil War and Reconstruction periods.",
    "poster": "https://m.media-amazon.com/images/M/MV5BYjUyZWZkM2UtMzYxYy00ZmQ3LWFmZTQtOGE2YjBkNjA3YWZlXkEyXkFqcGdeQXVyNzkwMjQ5NzM@._V1_UX182_CR0,0,182,268_AL_.jpg"
  },
  {
    "": 72,
    "name": "The Sandlot",
    "joy": 0.11830131445904954,
    "sadness": 0.08088978766430738,
    "fear": 0.08493427704752275,
    "anger": 0.09706774519716886,
    "neutral": 384,
    "surprise": 0.23053589484327602,
    "total": 989,
    "id": "tt0108037",
    "rank": 657,
    "plot": "In the summer of 1962, a new kid in town is taken under the wing of a young baseball prodigy and his rowdy team, resulting in many adventures.",
    "poster": "https://m.media-amazon.com/images/M/MV5BODllYjM1ODItYjBmOC00MzkwLWJmM2YtMjMyZDU3MGJhNjc4L2ltYWdlL2ltYWdlXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_UX182_CR0,0,182,268_AL_.jpg"
  },
  {
    "": 73,
    "name": "Central Station",
    "joy": 0.1443609022556391,
    "sadness": 0.11578947368421053,
    "fear": 0.08421052631578947,
    "anger": 0.13383458646616542,
    "neutral": 265,
    "surprise": 0.12330827067669173,
    "total": 665,
    "id": "tt0140888",
    "rank": 390,
    "plot": "An emotive journey of a former school teacher, who writes letters for illiterate people, and a young boy, whose mother has just died, as they search for the father he never knew.",
    "poster": "https://m.media-amazon.com/images/M/MV5BMjE3ZDA5ZmUtYTk1ZS00NmZmLWJhNTItYjIwZjUwN2RjNzIyXkEyXkFqcGdeQXVyMTkzODUwNzk@._V1_UX182_CR0,0,182,268_AL_.jpg"
  },
  {
    "": 74,
    "name": "Arrival",
    "joy": 0.0718132854578097,
    "sadness": 0.06463195691202872,
    "fear": 0.16337522441651706,
    "anger": 0.05116696588868941,
    "neutral": 554,
    "surprise": 0.15170556552962297,
    "total": 1114,
    "id": "tt2543164",
    "rank": 476,
    "plot": "A linguist works with the military to communicate with alien lifeforms after twelve mysterious spacecrafts appear around the world.",
    "poster": "https://m.media-amazon.com/images/M/MV5BMTExMzU0ODcxNDheQTJeQWpwZ15BbWU4MDE1OTI4MzAy._V1_UX182_CR0,0,182,268_AL_.jpg"
  },
  {
    "": 75,
    "name": "Nine Queens",
    "joy": 0.11357586512866016,
    "sadness": 0.09760425909494233,
    "fear": 0.055013309671694766,
    "anger": 0.19165927240461403,
    "neutral": 449,
    "surprise": 0.14374445430346053,
    "total": 1127,
    "id": "tt0247586",
    "rank": 513,
    "plot": "Two con artists try to swindle a stamp collector by selling him a sheet of counterfeit rare stamps (the \"nine queens\").",
    "poster": "https://m.media-amazon.com/images/M/MV5BMTYxMDdlYjItMDVkYy00MjYzLThhMTYtYjIzZjZiODk1ZWRmXkEyXkFqcGdeQXVyNDk3NzU2MTQ@._V1_UX182_CR0,0,182,268_AL_.jpg"
  },
  {
    "": 76,
    "name": "Gilda",
    "joy": 0.1696136214800262,
    "sadness": 0.08644400785854617,
    "fear": 0.07203667321545514,
    "anger": 0.12115258677144729,
    "neutral": 638,
    "surprise": 0.13294040602488538,
    "total": 1527,
    "id": "tt0038559",
    "rank": 867,
    "plot": "A small-time gambler hired to work in a Buenos Aires casino discovers his employer's new wife is his former lover.",
    "poster": "https://m.media-amazon.com/images/M/MV5BYWUxMzViZTUtNTYxNy00YjY4LWJmMjYtMzNlOThjNjhiZmZkXkEyXkFqcGdeQXVyMDI2NDg0NQ@@._V1_UX182_CR0,0,182,268_AL_.jpg"
  },
  {
    "": 77,
    "name": "Dil Bechara",
    "joy": 0.15165441176470587,
    "sadness": 0.13970588235294118,
    "fear": 0.10018382352941177,
    "anger": 0.07261029411764706,
    "neutral": 448,
    "surprise": 0.12408088235294118,
    "total": 1088,
    "id": "tt8110330",
    "rank": 465,
    "plot": "The emotional journey of two hopelessly in love youngsters, a young girl, Kizie, suffering from cancer, and a boy, Manny, whom she meets at a support group.",
    "poster": "https://m.media-amazon.com/images/M/MV5BNmI0MTliMTAtMmJhNC00NTJmLTllMzQtMDI3NzA1ODMyZWI1XkEyXkFqcGdeQXVyODE5NzE3OTE@._V1_UY268_CR16,0,182,268_AL_.jpg"
  },
  {
    "": 78,
    "name": "Le Dîner de Cons",
    "joy": 0.14035087719298245,
    "sadness": 0.11027568922305764,
    "fear": 0.07017543859649122,
    "anger": 0.16374269005847952,
    "neutral": 435,
    "surprise": 0.15204678362573099,
    "total": 1197,
    "id": "tt0119038",
    "rank": 802,
    "plot": "A few friends have a weekly fools' dinner, where each brings a fool along. Pierre finds a champion fool for next dinner. Surprise.",
    "poster": "https://m.media-amazon.com/images/M/MV5BZjFkOWM5NDUtODYwOS00ZDg0LWFkZGUtYzBkYzNjZjU3ODE3XkEyXkFqcGdeQXVyNzQzNzQxNzI@._V1_UX182_CR0,0,182,268_AL_.jpg"
  },
  {
    "": 79,
    "name": "Detachment",
    "joy": 0.10023310023310024,
    "sadness": 0.11305361305361306,
    "fear": 0.11771561771561771,
    "anger": 0.12937062937062938,
    "neutral": 286,
    "surprise": 0.2062937062937063,
    "total": 858,
    "id": "tt1683526",
    "rank": 735,
    "plot": "A substitute teacher who drifts from classroom to classroom finds a connection to the students and teachers during his latest assignment.",
    "poster": "https://m.media-amazon.com/images/M/MV5BMTM3NzQzMDA5Ml5BMl5BanBnXkFtZTcwODA5NTcyNw@@._V1_UY268_CR1,0,182,268_AL_.jpg"
  },
  {
    "": 80,
    "name": "Deliverance",
    "joy": 0.09975062344139651,
    "sadness": 0.0773067331670823,
    "fear": 0.08728179551122195,
    "anger": 0.09725685785536159,
    "neutral": 343,
    "surprise": 0.21072319201995013,
    "total": 802,
    "id": "tt0068473",
    "rank": 844,
    "plot": "Intent on seeing the Cahulawassee River before it's dammed and turned into a lake, outdoor fanatic Lewis Medlock takes his friends on a canoeing trip they'll never forget into the dangerous American back-country.",
    "poster": "https://m.media-amazon.com/images/M/MV5BZjBhYzU3NWItOWZjMy00NjI5LWFmYmItZmIyOWFlMDIxMWNiXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_UX182_CR0,0,182,268_AL_.jpg"
  },
  {
    "": 81,
    "name": "Loveless",
    "joy": 0.1021671826625387,
    "sadness": 0.1021671826625387,
    "fear": 0.11558307533539731,
    "anger": 0.10939112487100103,
    "neutral": 449,
    "surprise": 0.10732714138286893,
    "total": 969,
    "id": "tt6304162",
    "rank": 873,
    "plot": "A couple going through a divorce must team up to find their son who has disappeared during one of their bitter arguments.",
    "poster": "https://m.media-amazon.com/images/M/MV5BNjUzMDc1Y2ItY2NjNC00MGZkLThkZmEtNTUwNmQyNTdiNTJmXkEyXkFqcGdeQXVyNzUzNTQ2MjQ@._V1_UY268_CR3,0,182,268_AL_.jpg"
  },
  {
    "": 82,
    "name": "Escape from Alcatraz",
    "joy": 0.09213483146067415,
    "sadness": 0.08089887640449438,
    "fear": 0.12808988764044943,
    "anger": 0.1303370786516854,
    "neutral": 209,
    "surprise": 0.09887640449438202,
    "total": 445,
    "id": "tt0079116",
    "rank": 984,
    "plot": "Alcatraz is the most secure prison of its time. It is believed that no one can ever escape from it, until three daring men make a possible successful attempt at escaping from one of the most infamous prisons in the world.",
    "poster": "https://m.media-amazon.com/images/M/MV5BNDQ3MzNjMDItZjE0ZS00ZTYxLTgxNTAtM2I4YjZjNWFjYjJlL2ltYWdlXkEyXkFqcGdeQXVyNTAyODkwOQ@@._V1_UX182_CR0,0,182,268_AL_.jpg"
  },
  {
    "": 83,
    "name": "The Florida Project",
    "joy": 0.11165730337078651,
    "sadness": 0.0625,
    "fear": 0.09339887640449439,
    "anger": 0.11306179775280899,
    "neutral": 470,
    "surprise": 0.2893258426966292,
    "total": 1424,
    "id": "tt5649144",
    "rank": 874,
    "plot": "Set over one summer, the film follows precocious six-year-old Moonee as she courts mischief and adventure with her ragtag playmates and bonds with her rebellious but caring mother, all while living in the shadows of Walt Disney World.",
    "poster": "https://m.media-amazon.com/images/M/MV5BMjg4ZmY1MmItMjFjOS00ZTg2LWJjNDYtNDM2YmM2NzhiNmZhXkEyXkFqcGdeQXVyNTAzMTY4MDA@._V1_UX182_CR0,0,182,268_AL_.jpg"
  }
]
